import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useHistory } from 'react-router';

import ActionModal from 'src/components/Modal/ActionModal';
import { FORGOT_URL } from 'src/route_constants';

interface Props {
  close: () => void;
  message: string;
  show: boolean;
}
const AccountLockedModal = ({ close, message, show }: Props) => {
  const history = useHistory();

  const redirectToResetPage = () => {
    history.push(FORGOT_URL);
  };

  return (
    <ActionModal
      actions={[
        {
          buttonText: 'Cancel',
          buttonVariant: 'outlined',
          onClick: close,
        },
        {
          buttonText: 'Reset Password',
          onClick: redirectToResetPage,
        },
      ]}
      buttonContainer={{
        align: 'right',
      }}
      modalContent={
        <Box alignItems="center" display="flex" flexDirection="column">
          <Typography
            color="basic.grey"
            textAlign="center"
            variant="body1"
            whiteSpace="initial"
          >
            {message}
          </Typography>
        </Box>
      }
      modalSize="md"
      modalTitle={'Account Locked'}
      showModal={show}
      toggleModal={close}
    />
  );
};

export default AccountLockedModal;
